module.exports = __webpack_public_path__ + "static/posx-d235fb97df77b607be04b84125f40e7c.jpg";